import { atom } from 'jotai';

export const searchModalAtom = atom<boolean>(false);
